import { ImgHTMLAttributes, useMemo } from 'react';

import { getImageSrc } from './util/getImageSrc';

interface ImageProps extends ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
  src: string;
  serviceName?: string;
}

export function Image({ height, width, alt, src, className, serviceName = 'care', ...props }: ImageProps) {
  const resource = useMemo(() => {
    return getImageSrc({ src, type: 'image', serviceName });
  }, [src, serviceName]);

  return <img src={resource} height={height} width={width} alt={alt} className={className} {...props} />;
}
